var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataAreaChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 135,
    viewBox: "0 0 324 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M323 134.938H1V122.938L30.5 74.438L36.5 68.938L48.5 59.938H59.5L72.5 63.938L82 71.438L100.5 86.938L115 89.438L129 87.938L137.5 84.438L147.5 77.438L158 59.938L183 25.438L202 14.938H220.5L244 16.438L269 31.938L286 30.938L304 22.438L314 21.438H322L324 24.438L323 134.938Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 123.35L29.2974 76.6031C31.5491 72.8164 34.5287 69.5133 38.0641 66.8846V66.8846C51.9094 56.5901 71.3206 58.554 82.8233 71.4132L87.0682 76.1587C104.651 95.8144 136.058 93.5794 150.68 71.632L171.098 40.9837V40.9837C178.262 27.6479 191.136 18.3259 206.042 15.6831L216.32 13.8608",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 23.4379V23.4379C314.881 20.0732 305.708 20.7245 298.505 25.2125L295.247 27.2426C284.082 34.1987 269.407 33.9069 256.851 26.4791L249.428 22.0877C240.699 16.9244 231.04 14.1926 221.511 14.1926L216.456 14.1926",
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAreaChart);
export default __webpack_public_path__ + "static/media/no-data-area-chart.df755089678e54f9ef9bf38e03f71795.svg";
export { ForwardRef as ReactComponent };